import React from "react";
import { useHistory } from "react-router";
import { useTabs } from "../../../hooks";
import { TabOptions } from "../../../components/Tabs";

type Tabs = "current" | "pending" | "history";

const TAB_OPTIONS: TabOptions<Tabs> = [
  { label: "Current", value: "current" },
  { label: "Pending Signatures", value: "pending" },
  { label: "History", value: "history" },
];

export const DocumentsTabs = ({ current = "current" }: { current?: Tabs }) => {
  const history = useHistory<Tabs>();
  const [, tabs] = useTabs(TAB_OPTIONS, current, null, (newVal) => {
    let path = newVal === "current" ? "" : newVal;
    history.push(`/my-documents/data-protection-assessments/${path}`.replace(/\/$/, ""));
  });

  return <>{tabs}</>;
};
